module.exports = __webpack_public_path__ + "img/state5_laba.de99c54e.png";